import type { CreateObjectAddressDraft } from '../../../lib/address'

interface AddressMapInitialPoint {
  latitude: number
  longitude: number
}

export const mapAddressDraftToInitialPoint = (
  addressDraft: CreateObjectAddressDraft | null,
): AddressMapInitialPoint | null => {
  if (
    !addressDraft ||
    addressDraft.latitude === null ||
    addressDraft.longitude === null
  ) {
    return null
  }

  return {
    latitude: addressDraft.latitude,
    longitude: addressDraft.longitude,
  }
}
